import React from 'react';
import { Alert } from '@lightspeed/flame/Alert';
import Text from '@lightspeed/cirrus-text';

const PageError = ({ children }) => (
  <div className="react-page__listing">
    <Alert type="danger" noCloseBtn>
      <Text>{children}</Text>
    </Alert>
  </div>
);

export default PageError;
